/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const minus = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M4 9h12v2H4V9z" />
	</SVG>
);

export default minus;
